
import {
  REQUEST_NEWS,
  RECEIVE_NEWS,
  RECEIVE_NEWS_ERROR,
  GO_TO_NEWS,
  GO_TO_CATEGORY,
  GO_TO_SOLUTION,
  GO_TO_CONTENTTYPE,
  SET_CHECKEDAPPS,
} from '../actions/types'

export const initialState = {
	loading: false,
	news: []
};

export default function (prevState = initialState, action) {
	switch (action.type) {
		case REQUEST_NEWS:
			return Object.assign({}, prevState, {
				loading: true,
				news: [],
				error: null,
				currentNews: action.currentNews
			});
		case RECEIVE_NEWS:
			return Object.assign({}, prevState, {
				loading: false,
				news: action.news,
				error: null,
				currentNews: action.currentNews
			});
		case RECEIVE_NEWS_ERROR:
			return Object.assign({}, prevState, {
				loading: false,
				news: [],
				error: action.error
			});
		case GO_TO_NEWS:
			return Object.assign({}, prevState, {
				currentNews: action.currentNews,
			});
		case GO_TO_CATEGORY:
			// console.log(action.currentCategory)
			return Object.assign({}, prevState, {
				currentCategory: action.currentCategory,
			});
		case GO_TO_SOLUTION:
			// console.log(action.currentSolution)
			return Object.assign({}, prevState, {
				currentSolution: action.currentSolution,
			});
		case GO_TO_CONTENTTYPE:
			//console.log(action.currentContentType)
			return Object.assign({}, prevState, {
				currentContentType: action.currentContentType,
			});
		case SET_CHECKEDAPPS:
			//console.log('action.checkedApps', action.checkedApps)
			return Object.assign({}, prevState, {
				checkedApps: action.checkedApps,
			});
		default:
			return prevState;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/news.reducer.js